import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
export const StyledDescription = styled.div `
  ul {
    margin-top: 1rem;
    margin-bottom: 1rem;
    list-style: disc;
    list-style-position: inside;
    text-indent: calc(-1rem - 5px);
    margin-left: calc(1rem + 5px);

    li {
      list-style: inherit;
    }

    p:first-child {
      margin-top: 0;
    }
  }
`;
export const StyledFamilyWrapper = styled.div `
  .remarks {
    padding: 1rem;
    background-color: #f2f2f2;
  }
`;
export const StyledStandardEquipmentSectionWrapper = styled.div `
  width: 100%;

  td {
    p {
      margin-top: ${SYS_SPACE_FIXED_150};
      margin-bottom: ${SYS_SPACE_FIXED_200};
    }
  }

  button {
    display: flex;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    > p {
      flex: 1;
    }
  }

  .custom-item {
    padding: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
export const StyledSingleImage = styled.img `
  width: 100%;
  height: auto;
  object-fit: ${({ objectFit }) => objectFit};
`;
